import { priceStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsPrice";
import { contentSpacingStyles } from "@store/theme/common/mixins";
import { TYPOGRAPHY } from "@store/theme/design";
import { mediaOptions } from "@store/utilities/breakpointMediaQueries";
import breakpointValuesMediaQueries from "@store/utilities/breakpointValuesMediaQueries";
import { css } from "styled-components";

Object.assign(priceStyles, {
    productPrice: {
        wrapper: {
            css: css`
                ${props =>
                    breakpointValuesMediaQueries(
                        props.theme,
                        [{ values: [`${contentSpacingStyles()}`, null, 0], properties: ["margin-bottom"] }],
                        mediaOptions.min,
                    )}
            `,
        },
        priceWrapper: {
            css: css`
                display: flex;
                flex-direction: column;
                align-items: flex-start;
            `,
        },
        price: {
            priceText: {
                size: TYPOGRAPHY.size.larger,
                weight: TYPOGRAPHY.weight.black,
                css: css`
                    display: block;
                    line-height: ${TYPOGRAPHY.lineHeight.smaller};
                `,
            },
            unitOfMeasure: {
                unitOfMeasureText: {
                    size: TYPOGRAPHY.size.smallest,
                    css: css`
                        line-height: ${TYPOGRAPHY.lineHeight.small};
                    `,
                },
            },
        },
        retailPriceWrapper: {
            css: css`
                ${contentSpacingStyles("0.5em", null)}
            `,
        },
        retailPrice: {
            weight: TYPOGRAPHY.weight.bold,
            css: css`
                line-height: ${TYPOGRAPHY.lineHeight.smaller};
                margin-top: 0.2em;
            `,
        },
    },
});
